import { DEV } from 'consts';

// В будущем просто будем использовать для этого ФП apartmentStatus.tsx
export const APARTMENT_STATUS_FP_MENU = {
  key: '/feature-packages/apartmentsStatus',
  label: '(FP) Статус квартир',
  environment: [DEV],
};
